import React from 'react';
import { DumbbellIcon, FolderOpenIcon, LayersIcon, MapIcon, PrinterIcon, SlidersHorizontalIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: DumbbellIcon,
  color: 'text-teal-700'
}, {
  Icon: LayersIcon,
  color: 'text-amber-600'
}, {
  Icon: SlidersHorizontalIcon,
  color: 'text-blue-950'
}, {
  Icon: MapIcon,
  color: 'text-green-600'
}, {
  Icon: PrinterIcon,
  color: 'text-teal-700'
}, {
  Icon: FolderOpenIcon,
  color: 'text-amber-600'
}];
export function BenefitsGrid() {
  return <section className="bg-slate-100 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-12" data-mp="ew912h7ub5uc">
      <h2 className="mx-auto max-w-[620px] text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[26px]" data-id="element-13" data-mp="9zsalgd64fe3">
        Este no es otro libro lleno de teoría básica.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] text-[13px] font-bold uppercase leading-tight text-teal-700 md:text-[16px]" data-id="element-14" data-mp="3w4nmb88ywnh8">
        Es una biblioteca de herramientas visuales para profesionales.
      </p>
      <div className="mt-4 grid gap-2 text-left sm:grid-cols-2" data-id="element-15" data-mp="26pv0uw8qm29q">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i % icons.length];
        return <article key={b.title} className="flex gap-2.5 rounded-md border border-slate-200 bg-white p-3" data-id="element-16" data-mp="1wub4y9u6b3kz" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-17" data-mp="21t4lyc8o5cpw" />
              <div data-id="element-18" data-mp="2pigquzwyqyme">
                <h3 className="text-[13px] font-extrabold uppercase leading-tight text-blue-950 md:text-[14px]" data-id="element-19" data-mp="2pfunzdl0p7ai">
                  {b.title}
                </h3>
                <p className="mt-1 text-[13px] leading-[1.4] text-slate-600 md:text-[14px]" data-id="element-20" data-mp="2ggh925e4jqie">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
    </section>;
}